import * as Yup from "yup";

import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Rating,
  Select,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { Form, FormikProvider, useFormik } from "formik";

// import AlertDelete from "components/AlertDelete";
// import { Chance } from "chance";
// project-imports
// import IconButton from "components/@extended/IconButton";
import Loader from "components/Loader";
import PropTypes from "prop-types";
// assets
// import { Trash } from "iconsax-react";
import { dispatch } from "store";
// import { ThemeMode } from "config";
// third-party
import { openSnackbar } from "store/reducers/snackbar";
import { sendFeedback } from "store/reducers/users";
import { useState } from "react";

// import useUserAuthInfo from "hooks/useAuthInfo";

// const chance = new Chance();

// material-ui
// import { useTheme } from "@mui/material/styles";

// constant;

// ==============================|| SENDERID - ADD / EDIT ||============================== //
const allStatus = ["Sender IDs", "Credit Purchase", "Personalized Message", "Creating Sub Accounts", "Enquiries", "Others"];

const AddFeedback = ({ rating, onCancel, token, clientid }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [value, setValue] = useState(0);

  const schema = Yup.object().shape({
    title: rating ? Yup.string() : Yup.string().required("Title is required"),
    feedback: Yup.string().required("Feedback is required")
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: "",
      feedback: ""
    },
    validationSchema: schema,
    onSubmit: (values, { resetForm, setStatus, setSubmitting }) => {
      const data = {
        title: rating ? `${value} star(s)` : values.title,
        feedback: values.feedback
      };
      setSubmitting(true);

      sendFeedback(token, clientid, data)
        .then(() => {
          dispatch(
            openSnackbar({
              open: true,
              message: "Feedback sent successfully.",
              variant: "alert",
              alert: {
                color: "success"
              },
              close: true
            })
          );
          resetForm();
          setStatus({ success: false });
          setSubmitting(false);
        })
        .catch((err) => {
          setStatus({ success: false });
          dispatch(
            openSnackbar({
              open: true,
              message: err.message,
              variant: "alert",
              alert: { color: "error" },
              close: true
            })
          );
          setSubmitting(false);
        })
        .finally(() => {
          setIsLoading(false);
          setSubmitting(false);
          onCancel();
        });
    }
  });

  const { errors, touched, values, handleSubmit, isSubmitting, getFieldProps, setFieldValue } = formik;

  {
    isLoading && <Loader />;
  }

  return (
    <>
      <FormikProvider value={formik}>
        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
          <DialogTitle>We value your feedback</DialogTitle>
          <Divider />
          <DialogContent sx={{ p: 2.5 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                {rating ? (
                  <Stack
                    spacing={1.25}
                    alignItems="center"
                    sx={{
                      marginBottom: "1rem"
                    }}
                  >
                    <InputLabel htmlFor="customer-title">How was your experience?</InputLabel>
                    <Rating
                      name="simple-controlled"
                      value={value}
                      size="large"
                      onChange={(event, newValue) => {
                        setValue(newValue);
                      }}
                    />
                  </Stack>
                ) : (
                  <Stack spacing={1.25}>
                    <FormControl fullWidth>
                      <Select
                        id="column-hiding"
                        displayEmpty
                        {...getFieldProps("title")}
                        onChange={(event) => setFieldValue("title", event.target.value)}
                        input={<OutlinedInput id="select-column-hiding" placeholder="Sort by" />}
                        renderValue={(selected) => {
                          if (!selected) {
                            return <Typography variant="subtitle1">Select</Typography>;
                          }

                          return <Typography variant="subtitle2">{selected}</Typography>;
                        }}
                      >
                        {allStatus.map((column) => (
                          <MenuItem key={column} value={column}>
                            <ListItemText primary={column} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {errors.title && touched.title && (
                      <FormHelperText error id="standard-weight-helper-text">
                        {errors.title}
                      </FormHelperText>
                    )}
                  </Stack>
                )}
              </Grid>
              <Grid item xs={12}>
                <Stack spacing={1.25}>
                  {rating ? null : <InputLabel htmlFor="sfeedback">Your message</InputLabel>}
                  <TextField
                    fullWidth
                    multiline
                    minRows={5}
                    id="sfeedback"
                    value={values.feedback}
                    {...getFieldProps("feedback")}
                    placeholder="Tell us more"
                  />
                  {errors.feedback && touched.feedback && (
                    <FormHelperText error id="standard-weight-helper-text">
                      {errors.feedback}
                    </FormHelperText>
                  )}
                </Stack>
              </Grid>
            </Grid>
          </DialogContent>
          <Divider />
          <DialogActions sx={{ p: 2.5 }}>
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item></Grid>
              <Grid item>
                <Stack direction="row" spacing={2} alignItems="center">
                  <Button color="error" onClick={onCancel} variant="contained">
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={
                      isSubmitting ||
                      !formik.isValid ||
                      (formik.touched.title && formik.errors.title) ||
                      (formik.touched.feedback && formik.errors.feedback) ||
                      !formik.values.feedback
                    }
                  >
                    {isSubmitting ? <CircularProgress size={20} color="primary" /> : "Submit"}
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </DialogActions>
        </Form>
      </FormikProvider>
    </>
  );
};

AddFeedback.propTypes = {
  senderid: PropTypes.any,
  onCancel: PropTypes.func,
  token: PropTypes.string,
  targetId: PropTypes.any
};

export default AddFeedback;
